(() => {
  const dialog = document.getElementById('zs-size-guide');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const dataNode = dialog.querySelector('[data-zs-guide-data]');
  if (!dataNode) return;
  let models;
  try { models = JSON.parse(dataNode.textContent); } catch { return; }
  if (!models.length) return;
  const select = dialog.querySelector('[data-zs-guide-select]');
  const image = dialog.querySelector('[data-zs-guide-image]');
  const position = dialog.querySelector('[data-zs-guide-position]');
  const volume = dialog.querySelector('[data-zs-guide-volume]');
  const dimensions = dialog.querySelector('[data-zs-guide-dimensions]');
  const productLink = dialog.querySelector('[data-zs-guide-product]');
  let index = 0;
  let opener;
  let scrollState;
  let activeHandle = '';
  let touchStart;
  models.forEach((model, i) => {
    const option = document.createElement('option');
    option.value = String(i);
    option.textContent = model.name;
    select.append(option);
  });
  const draw = () => {
    const model = models[index];
    select.value = String(index);
    image.src = model.image;
    image.alt = model.alt;
    volume.textContent = model.volume;
    dimensions.textContent = model.dimensions;
    position.textContent = `${index + 1} / ${models.length}`;
    productLink.href = model.url;
    productLink.textContent = model.handle === activeHandle ? dialog.dataset.backLabel : dialog.dataset.productLabel;
  };
  const move = step => { index = (index + step + models.length) % models.length; draw(); };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-zs-size-guide-open]');
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    activeHandle = trigger.dataset.zsSizeGuideOpen || '';
    const match = models.findIndex(model => model.handle === activeHandle);
    index = match >= 0 ? match : models.findIndex(model => model.handle === 'the-organizer');
    if (index < 0) index = 0;
    draw();
    if (!dialog.open) {
      scrollState = {
        x: window.scrollX, y: window.scrollY,
        rootOverflow: document.documentElement.style.overflow,
        body: Object.fromEntries(['position', 'top', 'left', 'width', 'overflow'].map(key => [key, document.body.style[key]]))
      };
      document.documentElement.style.overflow = 'hidden';
      Object.assign(document.body.style, { position: 'fixed', top: `${-scrollState.y}px`, left: `${-scrollState.x}px`, width: '100%', overflow: 'hidden' });
      dialog.showModal();
    }
  });
  select.addEventListener('change', () => { index = Number(select.value); draw(); });
  dialog.querySelector('[data-zs-guide-prev]').addEventListener('click', () => move(-1));
  dialog.querySelector('[data-zs-guide-next]').addEventListener('click', () => move(1));
  dialog.querySelectorAll('[data-zs-guide-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (scrollState) {
      document.documentElement.style.overflow = scrollState.rootOverflow;
      Object.assign(document.body.style, scrollState.body);
      window.scrollTo({ left: scrollState.x, top: scrollState.y, behavior: 'instant' });
      scrollState = null;
    }
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('keydown', event => {
    if (event.target === select) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  const swipeArea = dialog.querySelector('[data-zs-guide-swipe]');
  swipeArea.addEventListener('touchstart', event => {
    if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  swipeArea.addEventListener('touchend', event => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) move(dx < 0 ? 1 : -1);
    touchStart = null;
  }, { passive: true });
  swipeArea.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
  productLink.addEventListener('click', event => {
    if (models[index].handle === activeHandle) {
      event.preventDefault();
      dialog.close();
    }
  });
})();
